import { TravelRiskPackageCode } from '@app/domain/model/eshop/travel/TravelRiskPackageCode';
import { ReactNode } from 'react';
import { BaggageInsuranceIcon } from '@app/app/_icons/BaggageInsuranceIcon';
import { BadAccidentsIcon } from '@app/app/_icons/BadAccidentsIcon';
import { CivilResponsibilityIcon } from '@app/app/_icons/CivilResponsibilityIcon';
import { MedicalExpensesInsuranceIcon } from '@app/app/_icons/MedicalExpensesInsuranceIcon';
import { TravelExpensesInsuranceIcon } from '@app/app/_icons/TravelExpensesInsuranceIcon';

export function getRiskIcon(code: Nullable<string>): ReactNode {
    if (!code || code === '') return null;

    switch (code) {
        case TravelRiskPackageCode.Baggage:
            return <BaggageInsuranceIcon className="size-14 text-primary-500" />;
        case TravelRiskPackageCode.Accident:
            return <BadAccidentsIcon className="size-14 text-primary-500" />;
        case TravelRiskPackageCode.CivilResponsibility:
            return <CivilResponsibilityIcon className="size-14 text-primary-500" />;
        case TravelRiskPackageCode.MedicalExpenses:
            return <MedicalExpensesInsuranceIcon className="size-14 text-primary-500" />;
        default:
            return <TravelExpensesInsuranceIcon className="size-14 text-primary-500" />;
    }
}
